import PropTypes from 'prop-types';

export default PropTypes.shape({
  s: PropTypes.string,
  m: PropTypes.string,
  l: PropTypes.string,
  xl: PropTypes.string,
});
